import { lazy } from 'react'

export const Contribute = lazy(() => import('./contribute'))
